import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import { Link2 } from 'lucide-react';

export default function ScreeningTestLink({ testId, selectedTestCard, onClose, open = true }) {
  if (!testId) return null;

  const testRoutes = {
    "/screening": { name: "Screening Test", url: `https://aievaluator.in/instructions?test_id=${testId}` },
    "/personality-test": { name: "Personality Test", url: `https://aievaluator.in/instructions?test_id=${testId}` },
    "/behavioral-test": { name: "Behavioral Test", url: `https://aievaluator.in/instructions?test_id=${testId}` },
    "/icoding": { name: "Coding Test", url: `https://aievaluator.in/instructions?test_id=${testId}` }
  };

  const selectedTest = testRoutes[selectedTestCard?.route] || { name: "Test", url: `https://aievaluator.in/instructions?test_id=${testId}` };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="text-3xl">Your Test Link</DialogTitle>
          <DialogDescription className="text-lg font-semibold mt-10">
            Click the link below to start your {selectedTest.name}.
          </DialogDescription>
        </DialogHeader>
        
        <Stack spacing="md" align="center" className="w-full max-w-[803px]">
          <Button
            variant="default"
            className={cn(
              "rounded-[22px] bg-primary w-full max-w-[626px] text-primary-foreground",
              "justify-center flex-wrap p-3 gap-2.5"
            )}
            onClick={() => window.location.href = selectedTest.url}
          >
            <Link2 className="w-[30px] h-[30px]" />
            <span className="break-words">{selectedTest.url}</span>
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
